import { GoogleLogin } from '@react-oauth/google';
import { grantTermsConsent } from '../hooks/useConsent';
import { trackEvent } from '../analytics/posthog';

interface Props {
  onSuccess: (credentialResponse: any) => void;
  onError?: () => void;
  width?: string;
}

export default function GoogleLoginButton({ onSuccess, onError, width }: Props) {
  const handleSuccess = (credentialResponse: any) => {
    grantTermsConsent();
    trackEvent('logged_in', { provider: 'google' });
    onSuccess(credentialResponse);
  };

  return (
    <div className="google-login-wrapper">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={onError}
        width={width}
        text="continue_with"
        shape="pill"
      />
    </div>
  );
}
